"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VesselLiveView = void 0;
const material_1 = require("@mui/material");
const React = require("react");
const api_1 = require("../../api");
const useVessel_1 = require("../ui/useVessel");
const VesselActions_1 = require("../ui/VesselActions");
const VesselLiveView = () => {
    const vessel = (0, useVessel_1.useVessel)(api_1.loadVesselDashboardQuery);
    if (!vessel) {
        return React.createElement(material_1.CircularProgress, null);
    }
    return React.createElement(React.Fragment, null,
        React.createElement(VesselActions_1.VesselActions, { vessel: vessel }),
        "TODO: live view");
};
exports.VesselLiveView = VesselLiveView;
